import { Box, Center, SimpleGrid, Text } from '@chakra-ui/react'
import { useMiniCalendar } from '../../contexts/MiniCalendarContext/Provider'
import { isToday, isSameMonth, isAfter, isBefore, startOfDay, isSameDay, getYear, getDayOfYear } from 'date-fns'
import DefaultDay from './component/DefaultDay'

const daysOfTheWeek = ['Do', 'Se', 'Te', 'Qua', 'Qui', 'Se', 'Sá']

export default function ContentMonth() {
  const { days, activeDay, calendarWith6LinesOfDays, period, dataOfTheDays, DayOfTheMonthComponent } = useMiniCalendar()

  console.log(days)

  return (
    <Box bg="light">
      <SimpleGrid columns={7}>
        {daysOfTheWeek.map((day, index) => (
          <Center key={index} border="1px solid" borderColor="borderColor">
            <Text fontSize="xs">{day}</Text>
          </Center>
        ))}
      </SimpleGrid>
      <SimpleGrid columns={7}>
        {days.map((day, index) => {
          const _isToday = isToday(new Date(day))
          const _isSameMonth = isSameMonth(new Date(activeDay), new Date(day))
          const _isInThePeriod =
            period && period.start && period.final
              ? isAfter(new Date(day), new Date(period.start || '')) ||
                isSameDay(new Date(day), new Date(period?.start))
                ? isBefore(new Date(startOfDay(new Date(day))), new Date(period.final || '')) ||
                  isSameDay(new Date(day), new Date(period?.final))
                : false
              : false
          const dataOfTheDay = dataOfTheDays?.[`${getYear(new Date(day))}_${getDayOfYear(new Date(day))}`]

          if (DayOfTheMonthComponent) {
            return (
              <DayOfTheMonthComponent
                key={index}
                calendarWith6LinesOfDays={calendarWith6LinesOfDays}
                _isSameMonth={_isSameMonth}
                _isInThePeriod={_isInThePeriod}
                _isToday={_isToday}
                day={day}
                dataOfTheDay={dataOfTheDay}
              />
            )
          }
          return (
            <DefaultDay
              key={index}
              calendarWith6LinesOfDays={calendarWith6LinesOfDays}
              _isSameMonth={_isSameMonth}
              _isInThePeriod={_isInThePeriod}
              _isToday={_isToday}
              day={day}
            />
          )
        })}
      </SimpleGrid>
    </Box>
  )
}
